/*
 * Google Maps styl (JSON export z Google Maps Styling Wizard) — sdílený
 * mezi frontendem (mapa poboček) a adminem (ACF Google Map pin picker,
 * viz admin/pobocka-map-style.js — tam je záměrně duplikovaný, protože
 * ten soubor není součástí webpack buildu).
 */
export const DEVIZY_MAP_STYLES = [
  {
    featureType: "administrative.locality",
    elementType: "all",
    stylers: [{ hue: "#ff0200" }, { saturation: 7 }, { lightness: 19 }, { visibility: "on" }],
  },
  {
    featureType: "administrative.locality",
    elementType: "labels.text",
    stylers: [{ visibility: "on" }, { saturation: "-3" }],
  },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [{ color: "#748ca3" }],
  },
  {
    featureType: "landscape",
    elementType: "all",
    stylers: [{ hue: "#ff0200" }, { saturation: -100 }, { lightness: 100 }, { visibility: "simplified" }],
  },
  {
    featureType: "poi",
    elementType: "all",
    stylers: [{ hue: "#ff0200" }, { saturation: "23" }, { lightness: "20" }, { visibility: "off" }],
  },
  {
    featureType: "poi.school",
    elementType: "geometry.fill",
    stylers: [{ color: "#ffdbda" }, { saturation: "0" }, { visibility: "on" }],
  },
  {
    // Obchody/obchodní centra zpátky zapnuté (výchozí Google ikony a
    // popisky, žádné vlastní přebarvení) — pobočky bývají v hypermarketech
    // (Tesco, Albert...), ať je i při defaultním zoomu vidět víc orientačních
    // bodů okolo. Ostatní poi.* (parky, památky, úřady...) zůstávají vypnuté.
    featureType: "poi.business",
    elementType: "all",
    stylers: [{ visibility: "on" }],
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ hue: "#ff0200" }, { saturation: "100" }, { lightness: 31 }, { visibility: "simplified" }],
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [{ color: "#f39247" }, { saturation: "0" }],
  },
  {
    featureType: "road",
    elementType: "labels",
    stylers: [{ hue: "#008eff" }, { saturation: -93 }, { lightness: 31 }, { visibility: "on" }],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry.stroke",
    stylers: [{ visibility: "on" }, { color: "#ffe5e5" }, { saturation: "0" }],
  },
  {
    featureType: "road.arterial",
    elementType: "labels",
    stylers: [{ hue: "#bbc0c4" }, { saturation: -93 }, { lightness: -2 }, { visibility: "simplified" }],
  },
  {
    featureType: "road.arterial",
    elementType: "labels.text",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [{ hue: "#ff0200" }, { saturation: -90 }, { lightness: -8 }, { visibility: "simplified" }],
  },
  {
    featureType: "transit",
    elementType: "all",
    stylers: [{ hue: "#e9ebed" }, { saturation: 10 }, { lightness: 69 }, { visibility: "on" }],
  },
  {
    featureType: "water",
    elementType: "all",
    stylers: [{ hue: "#e9ebed" }, { saturation: -78 }, { lightness: 67 }, { visibility: "simplified" }],
  },
];

/*
 * Nouzový fallback pro výchozí výřez mapy při načtení stránky, kdyby
 * někdy chyběl druhý argument (mapDefaults) v pobockyMapa() — normálně
 * se ale výchozí střed/zoom bere z admina ("Ovládání webu" → Pobočky,
 * viz devizy_mapa_vychozi_nastaveni() v inc/ovladani-webu.php a
 * page-uvod.php, kde se posílá do x-data). Hodnoty tady odpovídají
 * továrnímu nastavení: pokrývají moravskoslezský klastr (12 z 13
 * poboček), NE fitBounds přes úplně všechny — s Mariánskými Lázněmi na
 * druhé straně republiky by to zbytečně oddálilo pohled na drtivou
 * většinu poboček. Spočítané ručně z bounding boxu (Web Mercator vzorec
 * pro zoom). Klik na konkrétní město/pobočku dál používá plnohodnotný
 * automatický fitBounds/panTo (viz selectCity/selectBranch v index.js)
 * — tahle konstanta ovlivňuje jen prvotní pohled.
 */
export const DEVIZY_MAP_DEFAULT_CENTER = { lat: 49.678368, lng: 18.31741 };
export const DEVIZY_MAP_DEFAULT_ZOOM = 9;

/*
 * Vlastní marker (Lucide "map-pin", obarvený na --color-primary #E63312)
 * — plná výplň, kolečko uprostřed je vystřižené jako průhledná díra
 * (fill-rule evenodd, pin + kruh v jednom path), takže skrz něj je vidět
 * podkladová mapa. Jen syrová data (ne google.maps.Size/Point instance)
 * — ty se dají vytvořit až ve chvíli, kdy je "google" globálně dostupný
 * (viz initMap()/updateMap() v index.js).
 */
export const DEVIZY_MAP_MARKER_URL =
  "data:image/svg+xml;charset=UTF-8," +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"><path fill-rule="evenodd" fill="#E63312" d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0Z M15 10a3 3 0 1 0 -6 0a3 3 0 1 0 6 0Z"/></svg>'
  );
export const DEVIZY_MAP_MARKER_SIZE = { width: 40, height: 40 };
export const DEVIZY_MAP_MARKER_ANCHOR = { x: 20, y: 38 };
